const colours = {
  background: "#FFFFFF",
  container: "#FFFFFF",
  "background-dark": "#1a1a1a",
  "container-dark": "#2c2c2c",
  primary: "#852170",
  secondary: "#107A92",
  typography: "#084755",
  tertiary: "#B776B9",
  "greyscale-1": "#E8E8E9",
  "greyscale-2": "#030E23",
  "greyscale-3": "#939393",
};

module.exports = colours;
